exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-18d0a28b] .el-upload-dragger{height:130px!important;width:440px!important}[data-v-18d0a28b] .el-upload-dragger .el-icon-upload{margin:18px 0 16px}", ""]);

// exports
